import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./Preloader.css";
import gsap from "gsap";

import { useSpline } from "../context/SplineContext";

export default function Preloader() {
  const [progress, setProgress] = useState(0);
  const [preloaderActive, setPreloaderActive] = useState(true);
  const { splineObjectRef, isSplineReady } = useSpline();
  const location = useLocation();

  useEffect(() => {
    if (isSplineReady && splineObjectRef.current) {
      const obj = splineObjectRef.current;

      obj.position.y = -100;
      obj.scale.x = 2;
      obj.scale.y = 2;
      obj.scale.z = 2;

      let current = 0;
      const duration = 2500;
      const steps = 100;
      const intervalTime = duration / steps;

      const interval = setInterval(() => {
        current++;
        setProgress(current);

        if (current >= 100) {
          clearInterval(interval);

          gsap
            .timeline()
            .to(obj.position, { y: 0, duration: 1, delay: 0.4 })
            .to(
              obj.scale,
              { x: 1, y: 1, z: 1, duration: 1, delay: 0.4 },
              "-=1"
            );

          setTimeout(() => {
            setPreloaderActive(false);
            document
              .querySelector(".main-nav")
              .classList.remove("preloader-active");
            document
              .querySelector("body")
              .classList.remove("preloader-active-custom-nav");
          }, 600);

          setTimeout(() => {
            document
              .querySelector("body")
              .classList.remove("preloader-active-custom");
          }, 1500);
        }
      }, intervalTime);
      return () => clearInterval(interval);
    }
  }, [isSplineReady]);

  return (
    <>
      {preloaderActive && (
        <div className="preloader-wrapper">
          <span>{progress}%</span>
          <div className="preloader-text">
            <h3>Hello</h3>
            <h3>Sunshine</h3>
          </div>
        </div>
      )}
    </>
  );
}
